module.exports = __webpack_public_path__ + "img/est.6088c9ce.svg";